// extracted by mini-css-extract-plugin
export var addr = "styles-module--addr--8c6c0";
export var details = "styles-module--details--cfb88";
export var loc = "styles-module--loc--2c779";
export var map = "styles-module--map--54d95";
export var remaining = "styles-module--remaining--f20e6";
export var title = "styles-module--title--7a9d9";
export var wrapper = "styles-module--wrapper--ad680";